import request from '../request'
import configs from '@/configs'

//将对象转成url 参数
var parseParam=function(param, key){
  let paramStr="";
  if(['string','number','boolean'].indexOf(typeof(param)) >=0 ){
    paramStr+="&"+key+"="+encodeURIComponent(param);
  }
  else if(typeof(param)=='undefined' || param==null){
    if(typeof (key)!='undefined'){
      paramStr+="&"+key+"=";
    }
  }
  else{
    $.each(param,function(i){
      let k= key==null ? i : key+(param instanceof Array ? "["+i+"]" : "."+i);
      paramStr+='&'+parseParam(this, k);
    });
  }
  return paramStr.substr(1);
};

export default {
	log:{
		login:function(params){
	      return request.post(configs.API_URL+'/login/submit',params);
	    },
	    logout:function(){
	    	return request.post(configs.API_URL+'/login/out');
	    },
	    editPassword:function(params){
	    	return request.put(configs.API_URL+'/app/admin/account/password',params);
	    },
//	    getScode:function(params){
//	    	return request.get(configs.API_URL+'/login/auth_qrcode',{params: params});
//	    },
//	    checkScode:function(params){
//	    	return request.get(configs.API_URL+'/login/check',{params: params});
//	    },
//	    getCode:function(params){
//	    	return request.post(configs.API_URL+'/login/sendcode',params);
//	    }
	},
	main:{
		reports:function(params){
	    	return request.get(configs.API_URL+'/app/admin/statistics',{params: params});
	   	},
	   	menuTree:function(params){
	    	return request.get(configs.API_URL+'/app/admin/account/menu/tree',{params: params});
	   	}
	},
	account:{
	    accounts:function(params){
	    	return request.post(configs.API_URL+'/app/admin/accounts', params);
	    },
	    accountInfo:function(params){
	    	return request.get(configs.API_URL+'/app/admin/account',{params: params});
	    },
	    save:function(params){
	    	return request.post(configs.API_URL+'/app/admin/account',params);
	    },
	    delAccount:function(params){
	    	return request.delete(configs.API_URL+'/app/admin/account', {data:params});
	    },
	    disAccount:function(params){
	    	return request.put(configs.API_URL+'/app/admin/account', params);
	    },
	    saveRole:function(params){
	    	return request.put(configs.API_URL+'/app/admin/account/roles', params);
	    },
   	},
   	role:{
	    roles:function(params){
	    	return request.post(configs.API_URL+'/app/admin/roles', params);
	    },
	    roleInfo:function(params){
	    	return request.get(configs.API_URL+'/app/admin/role',{params: params});
	    },
	    save:function(params){
	    	return request.post(configs.API_URL+'/app/admin/role',params);
	    },
	    delRole:function(params){
	    	return request.delete(configs.API_URL+'/app/admin/role', {data:params});
	    },
	    disRole:function(params){
	    	return request.put(configs.API_URL+'/app/admin/role', params);
	    },
	    auth:function(params){
	    	return request.get(configs.API_URL+'/app/admin/role/auths/tree',{params: params});
	    },
	    saveAuth:function(params){
	    	return request.put(configs.API_URL+'/app/admin/role/auths', params);
	    }
   	},
   	customer:{
   		customers:function(params){
	    	return request.post(configs.API_URL+'/app/admin/customers', params);
	    },
	    save:function(params){
	    	return request.post(configs.API_URL+'/app/admin/customer', params);
	    },
	    info:function(params){
	    	return request.get(configs.API_URL+'/app/admin/customer',{params: params});
	    },
	    change:function(params){
	    	return request.put(configs.API_URL+'/app/admin/customer', params);
	    },
	    reset:function(params){
	    	return request.put(configs.API_URL+'/app/admin/customer/reset', params);
	    },
   	},
   	store:{
   		stores:function(params){
	    	return request.post(configs.API_URL+'/app/admin/stores', params);
	    },
	    info:function(params){
	    	return request.get(configs.API_URL+'/app/admin/store',{params: params});
	    },
	    save:function(params){
	    	return request.post(configs.API_URL+'/app/admin/store',params);
	    },
	    getCode:function(params){
	    	return request.get(configs.API_URL+'/app/admin/store/qrcode',{params: params});
	    },
	    del:function(params){
	    	return request.delete(configs.API_URL+'/app/admin/store', {data:params});
	    },
	    dis:function(params){
	    	return request.put(configs.API_URL+'/app/admin/store', params);
	    }
   	},
   	order:{
   		orders:function(params){
	    	return request.post(configs.API_URL+'/app/admin/orders', params);
	    },
	   	info:function(params){
	    	return request.get(configs.API_URL+'/app/admin/order/info', {params:params});
	    },
	    cancel:function(params){
	    	return request.put(configs.API_URL+'/app/admin/order', params);
	    },
	    refundOrder:function(params){
	    	return request.post(configs.API_URL+'/app/admin/order/refund', params);
	    },
      pdf:function(params){
        return request.put(configs.API_URL+'/app/admin/order/pdf', params);
      },
      exportURL(params){
        let query_params=parseParam(params);
        return configs.API_URL+'/client/order/pdf_export'+'?'+query_params;;
      }
   	},
   	system:{
   		systems:function(params){
	    	return request.get(configs.API_URL+'/app/admin/system/configs', params);
	    },
	    save:function(params){
	    	return request.put(configs.API_URL+'/app/admin/system/configs',params);
	    }
   	},
}



// WEBPACK FOOTER //
// ./src/utils/connect/index.js